import { render, staticRenderFns } from "./RequestWorkTypeStatusCheckbox.vue?vue&type=template&id=7f2079bc&scoped=true&"
import script from "./RequestWorkTypeStatusCheckbox.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypeStatusCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypeStatusCheckbox.vue?vue&type=style&index=0&id=7f2079bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2079bc",
  null
  
)

export default component.exports
import {QCheckbox,QTooltip,QColor} from 'quasar'
component.options.components = Object.assign({QCheckbox,QTooltip,QColor}, component.options.components || {})
